/**
 * MEDICLOUD REST API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { AiOccupationCategorizationOccupationApiModel } from './aiOccupationCategorizationOccupationApiModel';


export interface AiOccupationCategorizationResponseApiModel { 
    employerId: number;
    tenantId: number;
    occupations: Array<AiOccupationCategorizationOccupationApiModel>;
}

